import React from 'react';
import PropTypes from 'prop-types';

export default function Comments({ comments }) {
	/* eslint react/no-danger: 0 */
	/* filtered in server side code */
	return (
		<div
			className="content"
			dangerouslySetInnerHTML={{ __html: comments }}
		/>
	);
}

Comments.propTypes = {
	comments: PropTypes.string.isRequired
};
